import React, { useState } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import './SignIn.css';

function ForgotPassword() {
    const [numberPart, setNumberPart] = useState("");
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();

    const isValidPhoneNumber = (number) => {
        const full = `+994${number}`;
        return /^\+994(50|51|55|70|77)[0-9]{7}$/.test(full);
    };

    const handleSendCode = async (e) => {
        e.preventDefault();

        const fullNumber = `+994${numberPart}`;

        if (!isValidPhoneNumber(numberPart)) {
            setErrorMessage("Format: 50, 51, 55, 70, 77 ilə başlamalı və 9 rəqəm olmalıdır");
            return toast.warn("⚠️ Telefon nömrəsi düzgün deyil!");
        }

        setLoading(true);
        setErrorMessage("");

        try {
            await axios.post("https://api.herracim.az/api/Account/forgot-password", {
                emailOrPhone: fullNumber
            });

            toast.success("✅ Kod göndərildi!");
            setTimeout(() => {
                navigate("/reset-password", {
                    state: { phone: fullNumber }
                });
            }, 1500);
        } catch (err) {
            console.error("🚨 Xəta:", err);
            const errorMsg = err.response?.data || "İstifadəçi tapılmadı";
            setErrorMessage(errorMsg);
            toast.error(`❌ ${errorMsg}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='herrac-forgot-wrapper'>
            <div className='herrac-forgot-overlay'></div>

            <div className="herrac-forgot-container">
                <Link to="/giris" className='herrac-forgot-close' aria-label='Bağla'>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                </Link>

                <div className="herrac-forgot-card">
                    <div className='herrac-forgot-header'>
                        <div className='herrac-forgot-icon'>
                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                                <circle cx="24" cy="24" r="22" stroke="url(#gradient5)" strokeWidth="2"/>
                                <path d="M28 20H20C17.7909 20 16 21.7909 16 24V30C16 32.2091 17.7909 34 20 34H28C30.2091 34 32 32.2091 32 30V24C32 21.7909 30.2091 20 28 20Z" stroke="url(#gradient5)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M21 20V17C21 15.6739 21.5268 14.4021 22.4645 13.4645C23.4021 12.5268 24.6739 12 26 12C27.3261 12 28.5979 12.5268 29.5355 13.4645C30.4732 14.4021 31 15.6739 31 17V20" stroke="url(#gradient5)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <defs>
                                    <linearGradient id="gradient5" x1="0" y1="0" x2="48" y2="48">
                                        <stop offset="0%" stopColor="#fa709a"/>
                                        <stop offset="100%" stopColor="#fee140"/>
                                    </linearGradient>
                                </defs>
                            </svg>
                        </div>
                        <h2 className='herrac-forgot-title'>Şifrəni Unutdunuz?</h2>
                        <p className='herrac-forgot-subtitle'>Telefon nömrənizi daxil edin</p>
                    </div>

                    <form className="herrac-forgot-form" onSubmit={handleSendCode}>
                        <div className='herrac-forgot-input-group'>
                            <label className='herrac-forgot-label'>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M15.8333 3.75H4.16667C3.24619 3.75 2.5 4.49619 2.5 5.41667V14.5833C2.5 15.5038 3.24619 16.25 4.16667 16.25H15.8333C16.7538 16.25 17.5 15.5038 17.5 14.5833V5.41667C17.5 4.49619 16.7538 3.75 15.8333 3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M6.66667 7.5V12.5M10 7.5V12.5M13.3333 7.5V12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                Mobil nömrə
                            </label>
                            <div className="herrac-forgot-phone-wrapper">
                                <span className="herrac-forgot-phone-prefix">+994</span>
                                <input
                                    type="text"
                                    maxLength={9}
                                    value={numberPart}
                                    onChange={(e) => setNumberPart(e.target.value.replace(/\D/g, ""))}
                                    placeholder="50 123 45 67"
                                    className='herrac-forgot-input'
                                    required
                                    disabled={loading}
                                />
                            </div>
                        </div>

                        {errorMessage && (
                            <div className='herrac-forgot-error' role='alert'>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M10 6.66667V10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M10 13.3333H10.0083" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                {errorMessage}
                            </div>
                        )}

                        <button 
                            type="submit" 
                            className='herrac-forgot-button'
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className='herrac-forgot-spinner'></span>
                                    Göndərilir...
                                </>
                            ) : (
                                <>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M2.5 5.83333L10 10.8333L17.5 5.83333M3.33333 15H16.6667C17.5871 15 18.3333 14.2538 18.3333 13.3333V6.66667C18.3333 5.74619 17.5871 5 16.6667 5H3.33333C2.41286 5 1.66667 5.74619 1.66667 6.66667V13.3333C1.66667 14.2538 2.41286 15 3.33333 15Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    Kodu göndər
                                </>
                            )}
                        </button>
                    </form>

                    <div className='herrac-forgot-footer'>
                        <span 
                            onClick={() => navigate(-1)} 
                            className='herrac-forgot-footer-link'
                        >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            Geri qayıt
                        </span>
                    </div>
                </div>
            </div>

            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                closeOnClick
                pauseOnHover
                theme="light"
                style={{ zIndex: 99999 }}
            />
        </div>
    );
}

export default ForgotPassword;